import { useState, useEffect } from "react"

import appletOrConnectionPath from "app/scripts/applet_or_connection_path"
import SmallAppletCard from "shared/components/applet_card/ifttt_next/small_applet_card"

import { fetchRecommendedApplets } from "./api"
import Header from "./header"
import Subtitle from "./subtitle"
import Spinner from "shared/components/spinner"

import "./recommended_applets.scss"

interface Props {
  userIsOnboarding: boolean
  urls: {
    exploreUrl: string
  }
  onClickBack: () => void
}

interface Applets {
  id: string
}

const RecommendedApplets = ({ userIsOnboarding, urls, onClickBack }: Props) => {
  const [loading, setLoading] = useState(false)
  const [applets, setApplets] = useState<Applets[]>([])

  useEffect(() => {
    const effect = async () => {
      setLoading(true)
      const result = await fetchRecommendedApplets()
      setApplets(result)
      setLoading(false)
    }
    effect()
  }, [])

  const subtitleCopy = `We picked these Applets just for you. Tap any card to enable
    <br />
    your first automation.`

  return (
    <>
      <Header title="Recommended Applets" onClickBack={onClickBack} />
      <div styleName="container">
        {loading ? (
          <Spinner />
        ) : (
          <>
            <Subtitle>{subtitleCopy}</Subtitle>
            <ul className="web-applet-cards">
              {applets.map(applet => (
                <li className="my-web-applet-card web-applet-card" key={applet.id}>
                  <SmallAppletCard appletPath={appletOrConnectionPath(applet)} applet={applet} target="_blank" />
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
      <footer styleName="recommendation-footer">
        <div styleName="wide-content">
          <div>Learn how to automate and integrate every thing in your life.</div>
          <a href={urls.exploreUrl} className="button-tertiary button-on-color">
            Get started
          </a>
        </div>
        <div styleName="narrow-content">
          <a href={urls.exploreUrl} className="button-tertiary button-on-color">
            Get started
          </a>
        </div>
      </footer>
    </>
  )
}

export default RecommendedApplets
